import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";
import i18n from "../../../functions/i18next";

export default {
  props: {
    itemData: Object,
  },
  data() {
    return {
      user: null,
      roles: [],
      role: i18n.t("common.none"),
      roleOld: i18n.t("common.none"),
      role_id: "",
      email: "",
      emailOld: "",
      message: "",
      showRoles: false,
      updated: false,
      error: false,
      company_full: this.$store.state.company_full,
      disabled: true,
    };
  },
  created() {
    // get the user
    this.user = this.itemData;

    // set variables that will be shown on the screen
    this.email = this.itemData["email"];
    this.emailOld = this.email;

    if (this.itemData["role_id"]) {
      this.role_id = this.itemData["role_id"];
      this.role = this.itemData["role"];
      this.roleOld = this.role;
    }

    // get the roles
    this.$axios.get(baseUrl + "/companyroles").then((response) => {
      this.roles = response.data;
    });
  },
  methods: {
    /**
     *  Set the selected role of the user
     */
    setRole(name, id) {
      this.role = name;
      this.role_id = id;
      this.showRoles = false;
      this.setDisabled();
    },
    setDisabled() {
      if (this.email != this.emailOld || this.role != this.roleOld) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    /**
     * Update the user
     */
    updateUser() {
      let formData = new FormData();
      let mailChanged = "0";

      if (this.emailOld == this.email) {
        mailChanged = "0";
      } else {
        mailChanged = "1";
      }

      formData.append("id", this.user["id"]);
      formData.append("mail", this.email);
      formData.append("role_id", this.role_id);
      formData.append("mail_changed", mailChanged);

      this.$axios
        .post(baseUrl + "/userupdatesingle", formData)
        .then((response) => {
          if (response.data.response) {
            this.updated = true;
            this.message = i18n.t("manage_users.user_updated");
            EventBus.$emit("get-all-users");
            EventBus.$emit("get-all-roles");
          } else {
            this.error = true;
            this.message = i18n.t("common.invalid_email");
          }
        })
        .catch((thrown) => {
          this.error = true;
          this.message = i18n.t("common.something_went_wrong");
        });
    },
    /**
     * Reset the password
     */
    resetPassword() {
      let formData = new FormData();

      this.updated = true;
      this.message = i18n.t("manage_users.password_reset_send");

      formData.append("username", this.user["username"]);
      this.$axios
        .post(baseUrl + "/passwordreset", formData)
        .then((response) => {
          if (response.data) {
            this.updated = true;
            this.message = i18n.t("manage_users.password_reset_send");
          }
        })
        .catch((thrown) => {
          this.error = true;
          this.message = i18n.t("common.something_went_wrong");
        });
    },
    /**
     * Resend the invite
     */
    resendInvite() {
      let formData = new FormData();

      formData.append("mail", this.user["email"]);
      formData.append("role_id", this.role_id);
      formData.append("re-invite", true);

      this.$axios
        .post(baseUrl + "/invite", formData)
        .then((response) => {
          if (response.data) {
            this.updated = true;
            this.message = i18n.t("manage_users.user_invite_resend");
          }
        })
        .catch((thrown) => {
          this.error = true;
          this.message = i18n.t("common.something_went_wrong");
        });
    },
  },
};
